export function getSessionToken($chatForm = null) {
    if ($chatForm && $chatForm.length) {
        const token = $chatForm.attr('data-session-token');
        if (token) {
            return token;
        }
    }

    const modalToken = $('#growtypeChatSettingsModal .chat-settings').attr('data-token');
    if (modalToken) {
        return modalToken;
    }

    return $('.g-chatform').first().attr('data-session-token') || window.growtype_chat?.['gc-shell-chat']?.session_token || '';
}
